module.exports = __webpack_public_path__ + "img/tit-projects.2cc7a649.png";